<template>
	<div v-if="activeWidget">
		<template v-if="activeWidget.content.type == 'map' && activeWidget.content.data && activeWidget.content.data.myMap">
			<div class="ma-3" :key="uniqueKey">
				<template v-if="layers">
					<template v-if="layers.length">
						<template v-for="(layer) in layers">
							<MapLayerTree
								class="mt-3"
								v-bind:layer="layer"
								v-bind:title="layer.service.title"
								v-bind:unselectable="true"
								:key="layer.service.uniqueKey"
							/>
						</template>
					</template>
					<template v-else>
						<div>Sluoksnių nėra</div>
					</template>
				</template>
			</div>
		</template>
	</div>
</template>

<script>
	import MapLayerTree from "./tabs/components/MapLayerTree";

	export default {
		data: function(){
			var data = {
				layers: null,
				uniqueKey: 0
			};
			return data;
		},
		props: {
			cfg: Object
		},
		components: {
			MapLayerTree
		},
		computed: {
			activeWidget: {
				get: function(){
					return this.$store.state.activeWidget;
				}
			}
		},
		methods: {
			setLayers: function(){
				var layers = this.myMap.getLayers(true),
					visibleLayers = [];
				layers.forEach(function(layer){
					if (layer.get("visible")) {
						visibleLayers.push(layer);
					}
				});
				this.layers = visibleLayers;
			}
		},
		watch: {
			activeWidget: {
				immediate: true,
				handler: function(activeWidget){
					if (activeWidget && activeWidget.content.type == "map" && activeWidget.content.data && activeWidget.content.data.myMap && !activeWidget.content.data.myMap.noLegendInPreview) {
						this.myMap = activeWidget.content.data.myMap;
						this.layers = [];
						this.setLayers();
						this.myMap.map.getLayers().on("add", function(){
							this.setLayers();
						}.bind(this));
						this.myMap.map.getLayers().on("remove", function(){
							this.setLayers();
						}.bind(this));
					}
					this.uniqueKey += 1;
				}
			}
		}
	}
</script>